export const THEME_MODE_LIGHT = 'light'
export const THEME_MODE_DARK = 'dark'

export const COLOR_PALETTE = {
  SUCCESS: 'success',
  ERROR: 'error',
  PRIMARY: 'primary',
  INFO: 'info',
  SECONDARY: 'secondary',
  WARNING: 'warning',
  ORANGE: 'orange',
  GREY4: 'grey4'
}
